import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserSessionHandlerService {

  private timeOutHandler;

  constructor(private authService: AuthService,
              private router: Router) { }

  startUserSession(): void {
    if (this.timeOutHandler) {
      clearTimeout(this.timeOutHandler);
    }
    const sessionTimeInMilSec = environment.userSessionTimeInMin * 60 * 1000;
    this.timeOutHandler = setTimeout(() => {
      console.log('user session ended');
      this.setLogout();
    }, sessionTimeInMilSec);
  }

  private setLogout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
